<template>
  <div class="Action-form__input Action-form__input--contact">
    <div v-if="isPositive" class="Action-form__input__inputs">
      <TextInput
        class="Form-input__item"
        label="Firmatecknare"
        :disabled="isSubmitted"
        :value="action.ceoEmail"
        type="email"
        placeholder="Ange epost"
        @input="updateContactData($event, 'ceoEmail', index)"
        @blur="updateContact"
      />
      {{ /* :validation="$v.companyName" */ }}
    </div>
    <div v-if="isPositive" class="Action-form__input__inputs">
      <TextInput
        class="Form-input__item"
        label="Kontaktperson"
        :disabled="isSubmitted"
        :value="action.contactEmail"
        type="email"
        placeholder="Ange epost"
        @input="updateContactData($event, 'contactEmail', index)"
        @blur="updateContact"
      />
      {{ /* :validation="$v.organizationNumber" */ }}
    </div>
    <div v-else></div>
    <div class="Action-form__buttons">
      <div class="Action-form__buttons__confirm">
        <button
          class="Button"
          :disabled="isDisabledButton()"
          :class="getButtonClass()"
          @click="submit"
        >
          Bekräfta
        </button>
        <button
          v-if="!isApplicant && isSubmitted"
          class="Button Button--secondary"
          @click="unlockAction"
        >
          Lås upp för komplettering
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextInput from "@/components/forms/TextInput";

export default {
  name: "ApplicationActionMetaContact",
  components: { TextInput },
  props: {
    action: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isPositive: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("memberStore", ["isApplicant"]),
    isSubmitted() {
      return this.action.status === "SUBMITTED";
    }
  },
  methods: {
    ...mapActions("applicationStore", ["updateContact", "submitAction"]),
    isDisabledButton() {
      return !this.isDataValid();
    },
    isDataValid() {
      const emailRegEx = /\S+@\S+\.\S+/;

      return (
        emailRegEx.test(this.action.ceoEmail) &&
        emailRegEx.test(this.action.contactEmail)
      );
    },
    getButtonClass() {
      if (this.isDisabledButton()) {
        return "Button--primary-inactive";
      }
      return "Button--primary";
    },
    updateContactData(value, field, index) {
      this.action.ceoEmail =
        field === "ceoEmail" ? value : this.action.ceoEmail;
      this.action.contactEmail =
        field === "contactEmail" ? value : this.action.contactEmail;
    },
    updateContact() {
      this.updateContact({
        actionId: this.action.id,
        data: {
          actionIsPositive: true,
          ceoEmail: this.action.ceoEmail,
          contactEmail: this.action.contactEmail
        }
      });
    },
    submit(isClicked) {
      this.isDataValid() &&
        this.submitAction({
          actionId: this.action.id,
          submitted: isClicked
        });
    },
    unlockAction() {
      this.submitAction({
        actionId: this.action.id,
        submitted: false
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
